import { z } from 'zod';

export const emailAddressSchema = z.object({
  email: z.string().email(),
});

export type EmailAddressSchema = z.infer<typeof emailAddressSchema>;
